// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zzUv","colBig":"styles_colBig__DlSm0","colSmall":"styles_colSmall__AF53J","shopifyNameWrapper":"styles_shopifyNameWrapper___olBH"};